import React from "react";
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Button from 'react-bootstrap/Button';
import logo from '../../images/logoEutelsat.png';
import tv from '../../images/tvlineup.png';
import { LOCALES } from './../../i18nProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBroadcastTower, faHome } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';


function Menu(props) {
  const changeLanguage = (lng) => {
    props.onChangeValue(lng);
  }

  const logoAlign = {
    display: 'inline-flex',
    alignItems: 'center'
  }
  return (
    <div>
      <Navbar className="navbar navbar-expand-lg navbar-dark" expand="lg">
        <Container>
          <Navbar.Brand href="https://www.eutelsat.com/en/home.html" target="_blank">
            <img src={logo} alt="Logo" className="d-inline-block align-top" height="93px" />
          </Navbar.Brand>
          <Navbar.Toggle className="custom-toggler" aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav" className="align-items-center">
            <Nav className="me-auto">
              <Nav.Link className="mx-4" as={Link} to={{ pathname: "/", locale: props.locale }} style={logoAlign}>
                {/*  <img src={tv} alt="tv line up" className="d-inline-block align-top" /> */}
                <FontAwesomeIcon icon={faHome} size="2x" className="navIcon" />
                Channel Line-Up
              </Nav.Link>
              <Nav.Link className="mx-4" href="https://www.eutelsat.com/deploy_SorbamLight/pages/azimuthElevation.do?action=init" target="_blank" style={logoAlign}>
                {/* <FontAwesomeIcon icon={faBroadcastTower} size="2x" className="navIcon" /> */}
                <img src={tv} className="navIcon" alt="tv line up"/>
                Point your antenna
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
          <NavDropdown title={props.locale} id="basic-nav-dropdown">
            <NavDropdown.Item onClick={() => changeLanguage(LOCALES.ENGLISH)}>EN</NavDropdown.Item>
            <NavDropdown.Item onClick={() => changeLanguage(LOCALES.FRENCH)}>FR</NavDropdown.Item>
          </NavDropdown>
          <Nav.Link href="https://www.eutelsat.com/en/contact-us.html " target="_blank">
            <Button variant="light"><FormattedMessage id="menuButtonContactUs" /></Button>
          </Nav.Link>
        </Container>
      </Navbar >
    </div>
  );
}
export default Menu;